import { authModalStore } from "src/stores/auth-modal-store";

export const setReturnUrl = () => {
    if (globalThis.window !== undefined) {
        authModalStore.setReturnUrl(globalThis.window.location.pathname);
    }
};
